import type { FC, ReactElement } from 'react';
import { Button, type ButtonProps, type ColorlessIconProps, IconOzon } from '@direct-frontend/components';

const defaultIconLeft = (props: ColorlessIconProps): ReactElement => <IconOzon {...props} size="24" />;

interface OzonRegistrationButtonProps extends Partial<ButtonProps> {
    iconLeft?: (props: ColorlessIconProps) => ReactElement | null;
    showIcon?: boolean;
}

export const OzonRegistrationButton: FC<OzonRegistrationButtonProps> = (props) => {
    const { iconLeft = defaultIconLeft, showIcon = true, ...otherProps } = props;

    return (
        <Button {...otherProps} as="span" size="s" color="normal" iconLeft={showIcon ? iconLeft : undefined}>
            Создать Ozon ID
        </Button>
    );
};
